import { combineReducers } from 'redux';
import guide from './guide';

const rootReducer = combineReducers({
  guide
});

export default rootReducer;